import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-bs-trigger", "data-bs-content", "data-bs-placement"]

import { ref, onMounted } from "vue";
import { Popover } from "bootstrap";

export default /*#__PURE__*/_defineComponent({
  name: 'popover.component',
  props: {
  id: String,
  trigger: String,
  content: String,
  placement: String
},
  setup(__props) {



const el = ref();

onMounted(() => {
  if (el.value != null) {
    new Popover(el.value);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    ref_key: "el",
    ref: el,
    class: "d-inline-block",
    tabindex: "0",
    "data-bs-toggle": "popover",
    "data-bs-trigger": __props.trigger,
    "data-bs-content": __props.content,
    "data-bs-placement": __props.placement
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}
}

})